import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'

import FontAwesome from 'react-fontawesome'
import BoxButton from '../Layout/BoxButton'
import BoxSection from '../Layout/BoxSection'
import ModalAddFile from '../Shared/ModalAddFile'
import ModalAddCotizacion from './ModalAddCotizacion'

import {
    displayModalAddCotizacion,
    removeCotizacion,
    addFile,
    updateInputs
} from '../../actions/solicitudhoteles'


import {
    displayModalAddFile,
    selectFile,
    updateInputs as updateInputsModalAddFile,
    downloadFile
} from '../../actions/common'

import { isAllowedToViewComponent } from '../../utils/helpers'

class Cotizacion extends Component {

	render() {

        const { id, solicitudhoteles } = this.props

        const estado = solicitudhoteles.get('estado')

        if (!id) return null


        let accionesCotizaciones = []

        if (isAllowedToViewComponent('responsable_compras', solicitudhoteles.get('solicitud'))) {
            accionesCotizaciones = [
                <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" title="Adicionar cotización" onClick={ () => this.props.displayModalAddCotizacion(true, 'Adicionar cotización', 'create') } disabled={solicitudhoteles.get('estado') != 2 } />,
                <BoxButton key="ba[1][1]" size={14} contrast name="trash" title="Eliminar cotización" onClick={ () => this.props.removeCotizacion() } danger disabled={solicitudhoteles.get('estado') != 2}/>,
            ]
        }





        return (
        <Fragment>

            <BoxSection title="Comparativo de reservaciones" actions={ accionesCotizaciones }>

                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                    <thead>
                        <tr>
                            <th width="20px">
                                <input type="checkbox" style={{ verticalAlign: 'middle' }}  />
                            </th>
                            <th className="text-center" style={{ width: '5%' }}>No.</th>
                            <th>Proveedor hospedaje</th>
                            <th>Valor</th>
                            <th>Fecha de Cotización</th>
                            <th>Pantallazo cotización</th>
                            <th>Observaciones</th>
                            <th>Tipo de adjunto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (solicitudhoteles.getIn(['solicitud', 'cotizaciones']).count() > 0) ?
                                solicitudhoteles.getIn(['solicitud', 'cotizaciones']).map((x, n) => {


                                    const fileid = x.get('adjunto_id') ? x.getIn(['adjunto', 'id']) : null
                                    const filename = x.get('adjunto_id') ? x.getIn(['adjunto', 'nombre']) : null

                                    return (
                                        <tr key={ `tr[${n}]`}>
                                            <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') || false } onChange={ (e) => this.props.updateInputs(`solicitud.cotizaciones.${n}.selected`, e.target.checked) } /></td>
                                            <td className={`${estado==2 ? 'LinkToEdit' : ''} text-right`} onClick={ estado == 2 ? () => this.props.displayModalAddCotizacion(true, 'Editar cotización', 'edit', n) : null } >{n+1}</td>
                                            <td>{x.get('descripcion')}</td>
                                            <td className="text-right">{numeral(x.get('cotizado')).format('$0,0.00')}</td>
                                            <td className="text-right">{moment(x.getIn(['adjunto', 'created_at'])).format('DD/MM/YYYY')}</td>
                                            {
                                                x.get('adjunto_id') ? (
                                                    <td style={{ cursor: 'pointer' }} onClick={ x.get('adjunto') ? () => this.props.downloadFile(fileid, filename) : () => null }>
                                                        <i className="fa fa-download"></i>
                                                        <span style={{ marginLeft: '3px' }}>{`${x.getIn(['adjunto', 'nombre'])}`}</span>
                                                    </td>
                                                ) : (
                                                    <td>
                                                        {x.get('adjunto') ? `${x.getIn(['adjunto', 'nombre'])}` : 'Archivo sin adjuntar'}
                                                    </td>
                                                )
                                            }
                                            <td>
                                                {x.get('adjunto') ? `${x.getIn(['adjunto', 'observaciones'])}` : ''}
                                            </td>
                                            <td>
                                                {x.get('adjunto') ? `${x.getIn(['adjunto', 'clasificacion'])}` : ''}
                                            </td>
                                        </tr>
                                    )
                                })
                            :
                            <tr>
                                <td colSpan={ 6 } style={{ textAlign: 'center' }}>Para agregar una cotización haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                            </tr>
                        }
                    </tbody>
                </table>

            </BoxSection>

            <ModalAddCotizacion displayModalAddFile={ this.props.displayModalAddFile }/>

            <ModalAddFile
                action={ () => this.props.addFile('modalAddCotizacion.data.adjunto') }
            />


        </Fragment>
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudhoteles.get('id'),
        solicitudhoteles: state.solicitudhoteles
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalAddCotizacion: (show, title, mode, index) => dispatch(displayModalAddCotizacion(show, title, mode, index)),
        removeCotizacion: () => dispatch(removeCotizacion()),
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        updateInputsModalAddFile: (path, value) => dispatch(updateInputsModalAddFile(path, value)),
        selectFile: (file) => dispatch(selectFile(file)),
        addFile: (path) => dispatch(addFile(path)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(Cotizacion)



// WEBPACK FOOTER //
// ./src/components/SolicitudHoteles/Cotizacion.jsx